// import React, { useState } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faHome, faDatabase, faBell, faQuestionCircle, faFolderOpen, faCog, faChartLine, faMessage, faFolderMinus, faUserCircle, faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
// import './Sidebar.scss';
// import { useNavigate } from 'react-router-dom';
// import {ReactComponent as Logo} from '../../Assets/svg/dm_logo.svg'
// import LogoExpanded from '../../Assets/img/dm-logo.png'
// import { Dropdown } from 'react-bootstrap';
// import { useMsal } from '@azure/msal-react';

// const Sidebar = () => {
//     const [expanded, setExpanded] = useState(false);
//     const [active, setActive] = useState('home');
//     const [submenuOpen, setSubmenuOpen] = useState(null);
//     const navigate = useNavigate();
//     const { instance, inProgress } = useMsal();
//     let activeAccount;

//     if (instance) {
//         activeAccount = instance.getActiveAccount();
//     }

//     const handleLogoutRedirect = () => {
//         instance.logoutRedirect();
//     };

//     const handleExpandedToggle = () => setExpanded(!expanded);
//     const handleSetActive = (page) => setActive(page);
//     const handleSubmenuToggle = (menu) => setSubmenuOpen(submenuOpen === menu ? null : menu);
//     const handleNavigateTo = (route) => {
//         navigate(route);
//     }

//     return (
//         <div className={`sidebar ${expanded ? 'expanded' : ''}`}>
//             <div className={`sidebar-item brand ${active === 'brand' ? 'active' : ''}`} onClick={() => handleExpandedToggle()}>
//                 {/* <FontAwesomeIcon icon={faHashtag} /> */}
//                 {/* <img src={logo} alt='DM' /> */}
//                 {expanded ? <img src={LogoExpanded} /> : <Logo />}
//             </div>
//             <div className={`user-item ${expanded ? 'expanded' : ''}`}>
//                 {/* User details */}
//                 <FontAwesomeIcon icon={faUserCircle} className="text-primary" />
//                 {expanded && (
//                     <div className='user-info'>
//                         <div className="user-info-text d-flex flex-column align-items-start">
//                             <p className='fw-bold m-0'>{activeAccount && activeAccount.name}</p>
//                             <p className="small fw-normal text-secondary-emphasis m-0">{activeAccount && activeAccount.username.split('@')[0]}</p>
//                         </div>
//                         <Dropdown align="end">
//                             <Dropdown.Toggle variant="transparent" id="dropdown-profile">
//                             </Dropdown.Toggle>

//                             <Dropdown.Menu>
//                                 <Dropdown.Item as="button">
//                                     Sign out
//                                 </Dropdown.Item>
//                             </Dropdown.Menu>
//                         </Dropdown>
//                     </div>
//                 )}
//             </div>
//             <div className='action-items'>
//                 <div className={`sidebar-item ${active === 'home' ? 'active' : ''}`} onClick={() => handleNavigateTo('/home')}>
//                     <FontAwesomeIcon icon={faHome} />
//                     {expanded && <span>Home</span>}
//                     <div></div>
//                 </div>
//                 <div className={`sidebar-item ${active === 'reports' ? 'active' : ''}`} onClick={() => { handleSetActive('reports'); handleNavigateTo('/reports') }}>
//                     <FontAwesomeIcon icon={faChartLine} />
//                     {expanded && <span>Reports</span>}
//                     <div></div>
//                 </div>
//                 <div
//                     className={`sidebar-item ${active === 'data' ? 'active' : ''} ${submenuOpen === 'data' ? 'submenu-open' : ''}`}
//                     onClick={() => handleSubmenuToggle('data')}
//                 >
//                     <FontAwesomeIcon icon={faDatabase} />
//                     {expanded && <span>Data</span>}
//                     <div></div>
//                     <div className={`submenu ${submenuOpen === 'data' ? 'show' : ''}`}>
//                         <h5>Data</h5>
//                         <div className='submenu-item' onClick={() => handleNavigateTo('/data-extraction')}>Export to CSV</div>
//                         <div className='submenu-item' onClick={() => handleNavigateTo('/docs/api/v1')}>API Connection</div>
//                     </div>
//                 </div>
//                 <div className={`sidebar-item ${active === 'files' ? 'active' : ''}`} onClick={() => { handleSetActive('files'); handleNavigateTo('/files') }}>
//                     <FontAwesomeIcon icon={faFolderOpen} />
//                     {expanded && <span>My Files</span>}
//                     <div></div>
//                 </div>
//                 <div className={`sidebar-item ${active === 'chat' ? 'active' : ''}`} onClick={() => { handleSetActive('chat'); handleNavigateTo('/chat') }}>
//                     <FontAwesomeIcon icon={faMessage} />
//                     {expanded && <span>Chat</span>}
//                     <div></div>
//                 </div>
//                 <div
//                     className={`sidebar-item ${active === 'docu-chat' ? 'active' : ''} ${submenuOpen === 'docu-chat' ? 'submenu-open' : ''}`}
//                     onClick={() => handleSubmenuToggle('docu-chat')}
//                 >
//                     <FontAwesomeIcon icon={faFolderMinus} />
//                     {expanded && <span>DocuChat</span>}
//                     <div></div>
//                     <div className={`submenu ${submenuOpen === 'docu-chat' ? 'show' : ''}`}>
//                         <h5>DocuChat</h5>
//                         <div className='submenu-item' onClick={() => handleNavigateTo('/docu-chat')}>Chat</div>
//                         <div className='submenu-item' onClick={() => handleNavigateTo('/chat-files')}>Chat Files</div>
//                     </div>
//                 </div>
//                 {/* <div className={`sidebar-item ${active === 'files' ? 'active' : ''}`} onClick={() => { handleSetActive('files'); handleNavigateTo('/chat-files') }}>
//                     <FontAwesomeIcon icon={faFolderMinus} />
//                     {expanded && <span>DocuChat</span>}
//                 </div> */}
//                 <div className={`sidebar-item ${active === 'notifications' ? 'active' : ''}`} onClick={() => { handleSetActive('notifications'); handleNavigateTo('/notifications') }}>
//                     <FontAwesomeIcon icon={faBell} />
//                     {expanded && <span>Notifications</span>}
//                     <div></div>
//                 </div>
//                 <div
//                     className={`sidebar-item ${active === 'admin' ? 'active' : ''} ${submenuOpen === 'admin' ? 'submenu-open' : ''}`}
//                     onClick={() => handleSubmenuToggle('admin')}
//                 >
//                     <FontAwesomeIcon icon={faCog} />
//                     {expanded && <span>Admin</span>}
//                     <div></div>
//                     <div className={`submenu ${submenuOpen === 'admin' ? 'show' : ''}`}>
//                         <h5>Settings</h5>
//                         <div className='submenu-item' onClick={() => handleNavigateTo('/admin-notifications')}>Notifications</div>
//                         <div className='submenu-item' onClick={() => handleNavigateTo('/support')}>Tickets</div>
//                         <div className='submenu-item' onClick={() => handleNavigateTo('/admin-news')}>News</div>
//                         <div className='submenu-item' onClick={() => handleNavigateTo('/admin-config')}>Admin</div>
//                     </div>
//                 </div>
//                 <div className={`sidebar-item ${active === 'help' ? 'active' : ''}`} onClick={() => handleSetActive('help')}>
//                     <FontAwesomeIcon icon={faQuestionCircle} />
//                     {expanded && <span>Help</span>}
//                     <div></div>
//                 </div>
//                 <div className='sidebar-item' onClick={() => handleExpandedToggle()}>
//                     {expanded ? <FontAwesomeIcon icon={faArrowLeft} /> : <FontAwesomeIcon icon={faArrowRight} />}
//                     {expanded && <span>Collapse</span>}
//                     <div></div>
//                 </div>
//             </div>

//             {submenuOpen && <div className="overlay" onClick={() => handleSubmenuToggle(null)}></div>}
//         </div>
//     );
// };

// export default Sidebar;

import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHome,
    faDatabase,
    faBell,
    faQuestionCircle,
    faFolderOpen,
    faCog,
    faChartLine,
    faMessage,
    faFolderMinus,
    faUserCircle,
    faArrowRight,
    faArrowLeft,
    faListSquares,
    faBook,
    faUserFriends,
    faNewspaper,
} from "@fortawesome/free-solid-svg-icons";
import { Accordion } from "react-bootstrap";
import "./Sidebar.scss";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../../Assets/svg/dm_logo.svg";
import LogoExpanded from "../../Assets/img/dm-logo.png";
import { Dropdown } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";
import { faListAlt } from "@fortawesome/free-regular-svg-icons";
import SmartCPGIcon from "../SmartCPGIcon/SmartCPGIcon";

const Sidebar = () => {
    const [expanded, setExpanded] = useState(false);
    const [active, setActive] = useState("home");
    const navigate = useNavigate();
    const { instance } = useMsal();
    let activeAccount;

    if (instance) {
        activeAccount = instance.getActiveAccount();
    }

    const handleExpandedToggle = () => setExpanded(!expanded);
    const handleNavigateTo = (route) => navigate(route);

    return (
        <div className={`sidebar ${expanded ? "expanded" : ""}`}>
            {/* Logo Section */}
            <div
                className={`sidebar-item brand ${active === "brand" ? "active" : ""}`}
                onClick={() => handleExpandedToggle()}
            >
                {expanded ? <img src={LogoExpanded} alt="Logo" /> : <Logo />}
            </div>

            {/* User Section */}
            <div className={`user-item ${expanded ? "expanded" : ""}`}>
                <FontAwesomeIcon icon={faUserCircle} className="text-primary" />
                {expanded && (
                    <div className="user-info">
                        <div className="user-info-text d-flex flex-column align-items-start">
                            <p className="fw-bold m-0">{activeAccount && activeAccount.name}</p>
                            <p className="small fw-normal text-secondary-emphasis m-0">
                                {activeAccount && activeAccount.username.split("@")[0]}
                            </p>
                        </div>
                        <Dropdown align="end">
                            <Dropdown.Toggle variant="transparent" id="dropdown-profile" />
                            <Dropdown.Menu>
                                <Dropdown.Item as="button">Sign out</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                )}
            </div>

            {/* Action Items */}
            <div className="action-items">
                <Accordion flush alwaysOpen className="d-flex flex-column justify-content-between h-100">
                    <div className="top-items">
                        <div
                            className={`sidebar-item ${active === "home" ? "active" : ""}`}
                            onClick={() => handleNavigateTo("/home")}
                        >
                            <FontAwesomeIcon icon={faHome} />
                            {/* <SmartCPGIcon name="home" /> */}
                            {expanded && <span>Home</span>}
                        </div>
                        <div
                            className={`sidebar-item ${active === "news" ? "active" : ""}`}
                            onClick={() => handleNavigateTo("/news")}
                        >
                            <FontAwesomeIcon icon={faNewspaper} />
                            {expanded && <span>News</span>}
                        </div>
                        <div
                            className={`sidebar-item ${active === "dashboards" ? "active" : ""}`}
                            onClick={() => handleNavigateTo("/dashboards")}
                        >
                            <FontAwesomeIcon icon={faChartLine} />
                            {expanded && <span>Dashboards</span>}
                        </div>
                        <Accordion.Item eventKey="data">
                            <Accordion.Header onClick={() => setExpanded(true)}>
                                <div
                                    className={`sidebar-item ${active === "data" ? "active" : ""}`}
                                >
                                    <FontAwesomeIcon icon={faDatabase} />
                                    {expanded && <span>Data Management</span>}
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/data-extraction")}
                                >
                                    Export to CSV
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/extraction-templates")}
                                >
                                    Extraction Templates
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/scheduled-tasks")}
                                >
                                    Scheduled Tasks Monitor
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/docs/api/v1")}
                                >
                                    API Connection
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="files">
                            <Accordion.Header onClick={() => setExpanded(true)}>
                                <div
                                    className={`sidebar-item ${active === "docu-chat" ? "active" : ""}`}
                                >
                                    <FontAwesomeIcon icon={faFolderMinus} />
                                    {expanded && <span>Files</span>}
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div 
                                    className="submenu-item" 
                                    onClick={() => handleNavigateTo('/files')}
                                >
                                    My Documents
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/chat-files")}
                                >
                                    Chat Files
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="agent">
                            <Accordion.Header onClick={() => setExpanded(true)}>
                                <div
                                    className={`sidebar-item ${active === "agent" ? "active" : ""}`}
                                >
                                    <FontAwesomeIcon icon={faUserFriends} />
                                    {expanded && <span>Agent</span>}
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/chat")}
                                >
                                    Chat
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/docu-chat")}
                                >
                                    DocuChat
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/dashboard-library")}
                                >
                                    Storyteller
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="catalogs">
                            <Accordion.Header onClick={() => setExpanded(true)}>
                                <div
                                    className={`sidebar-item ${active === "catalogs" ? "active" : ""}`}
                                >
                                    <FontAwesomeIcon icon={faBook} />
                                    {expanded && <span>Catalogs</span>}
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/product-catalog")}
                                >
                                    Products
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/store-catalog")}
                                >
                                    Stores
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </div>
                    <div className="bottom-items">
                        <Accordion.Item eventKey="admin">
                            <Accordion.Header onClick={() => setExpanded(true)}>
                                <div
                                    className={`sidebar-item ${active === "admin" ? "active" : ""}`}
                                >
                                    <FontAwesomeIcon icon={faCog} />
                                    {expanded && <span>Admin</span>}
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/admin-notifications")}
                                >
                                    Notifications
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/support")}
                                >
                                    Tickets
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/admin-news")}
                                >
                                    News
                                </div>
                                <div
                                    className="submenu-item"
                                    onClick={() => handleNavigateTo("/admin-config")}
                                >
                                    Admin
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <div
                            className={`sidebar-item ${active === "notifications" ? "active" : ""}`}
                            onClick={() => handleNavigateTo("/notifications")}
                        >
                            <FontAwesomeIcon icon={faBell} />
                            {expanded && <span>Notifications</span>}
                        </div>
                        <div
                            className={`sidebar-item ${active === "help" ? "active" : ""}`}
                            onClick={() => handleNavigateTo("/help")}
                        >
                            <FontAwesomeIcon icon={faQuestionCircle} />
                            {expanded && <span>Help</span>}
                        </div>
                    </div>
                </Accordion>
            </div>

            {/* Toggle Button */}
            <div
                className="sidebar-item"
                onClick={() => handleExpandedToggle()}
            >
                <FontAwesomeIcon icon={expanded ? faArrowLeft : faArrowRight} />
                {expanded && <span>Collapse</span>}
            </div>
        </div>
    );
};

export default Sidebar;
